









































import mixins from 'vue-typed-mixins';
import cloneDeep from 'lodash.clonedeep';
import ProviderForm from '@/components/provider/ProviderForm.vue';
import ProviderUtils, { ServiceProvider } from '../../utils/ProviderUtils';
import ChangeStatus from './ChangeStatus.vue';
export default mixins().extend({
  components: {
    ProviderForm,
    ChangeStatus,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    pristine?: Partial<ServiceProvider>;
    provider?: Partial<ServiceProvider>;
  } {
    return {
      pristine: undefined,
      provider: undefined,
    };
  },
  async mounted() {
    this.$loading(true);
    try {
      if (this.id) {
        const resp = await Promise.all([
          ProviderUtils.api.instance.get(this.id),
        ]);
        this.pristine = resp[0];
        this.provider = cloneDeep(this.pristine);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },
  methods: {
    async submit() {
      if (this.provider) {
        try {
          this.$alert.hide('submit');
          await ProviderUtils.api.instance.update(this.provider);
          this.pristine = cloneDeep(this.provider);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.serviceProvider.label')],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
